module.exports = __webpack_public_path__ + "img/sheffield-united-logo-icon.7b733864.png";